import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-success',
  templateUrl: './fh-svg-success.component.html',
  styleUrl: './fh-svg-success.component.scss'
})
export class FhSvgSuccessComponent {
  @Input() color: string = '';
}
